import type { SlotPropsOrFn } from '../types/data-table-slot-props';

export function resolveSlotProps<TProps, TContext>(
  propsOrFn: SlotPropsOrFn<TProps, TContext> | undefined,
  context: TContext,
): Partial<TProps> {
  if (typeof propsOrFn === 'function') {
    return propsOrFn(context);
  }

  return propsOrFn ?? {};
}
